import React, { useEffect, useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import { showModal } from '../../../store/actions/modalActions'
import { ModalTypes } from '../../../types/modals'
import { User } from '../../../entity/User'
import AppButton from '../../buttons/AppButton/AppButton'
import Loader from '../../Loader/Loader'
import { UserData } from './UserData/UserData'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import { RoutesPaths } from '../../../router'
import { FormattedMessage } from 'react-intl'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectUsers, selectUsersIsLoading } from '../../../store/selectors/userSelectors'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { fetchUsers } from '../../../store/async-thunks/users/fetchUsers'
import { userActions } from '../../../store/slices/userSlice'
import { maxRequestTime } from '../../../api/api'

export const Controller = () => {
    const dispatch = useAppDispatch()

    const users = useAppSelector(selectUsers)
    const isLoading= useAppSelector(selectUsersIsLoading)
    const [isRequestTimeExpired, setIsRequestTimeExpired] = useState(false)

    const authUser = new User()
    const defaultUserTab =
        users[0]?.login === authUser.login ? users[1]?.login : users[0]?.login

    const isEmpty =
        !users.length ||
        (users.length === 1 && users[0].login === authUser.login)

    const handleOnAddUser = () => {
        dispatch(showModal(ModalTypes.ADD_NEW_USER_MODAL, {}))
    }

    useEffect(() => {
        dispatch(fetchUsers())
    }, []) // eslint-disable-line

    useEffect(() => {
        if (isLoading) {
            setTimeout(() => setIsRequestTimeExpired(true), maxRequestTime)
        }
    }, [isLoading]) // eslint-disable-line

    useEffect(() => {
        if (isLoading && isRequestTimeExpired) {
            dispatch(
                showModal(ModalTypes.ERROR_MODAL, {
                    request: fetchUsers,
                    onCancel: 'cancel',
                    title: <FormattedMessage id="errors.server.request" />,
                    message: (
                        <FormattedMessage id="errors.server.requestTimeExceeded" />
                    ),
                })
            )
            setIsRequestTimeExpired(false)
            dispatch(userActions.cancelFetchUsers())
        }
    }, [isRequestTimeExpired]) // eslint-disable-line

    if (!authUser.isAdministratorOrOwner()) {
        return <Redirect to={{ pathname: RoutesPaths.NOT_ENOUGH_PRIVILEGE }} />
    }

    if (isLoading) return <Loader />

    return (
        <div className="ps-4 pb-3 pt-3 pe-4 flex-1">
            <div className="p-4">
                <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey={defaultUserTab}
                >
                    <Row>
                        <Col sm={3}>
                            <div className="d-flex justify-content-between">
                                <h3 className="app-color-text ms-2">
                                    <FormattedMessage id="user.controller.users" />
                                </h3>
                                <AppButton
                                    variant="add"
                                    onClick={handleOnAddUser}
                                    className="bt btn-add p-1 mt-2 mb-2 me-1 ms-auto ps-3 pe-3"
                                    tooltip="add-new-user"
                                />
                            </div>
                            <OverlayScrollbarsComponent
                                className="pe-3"
                                style={{ maxHeight: 'calc(100vh - 170px)' }}
                            >
                                <Nav
                                    variant="pills"
                                    className="flex-column"
                                >
                                    {isEmpty && (
                                        <Nav.Item>
                                            <div
                                                style={{ opacity: '0.5' }}
                                                className="h4 text-secondary vh-users d-flex align-items-center justify-content-center"
                                            >
                                                <FormattedMessage id="user.controller.noData" />
                                            </div>
                                        </Nav.Item>
                                    )}
                                    {users.map((user) =>
                                        authUser.login !== user.login ? (
                                            <Nav.Item key={user.login}>
                                                <Nav.Link
                                                    className="app-color-text user-naw-link"
                                                    eventKey={user.login}
                                                >
                                                    {user.login}
                                                </Nav.Link>
                                            </Nav.Item>
                                        ) : null
                                    )}
                                </Nav>
                            </OverlayScrollbarsComponent>
                        </Col>
                        <Col
                            className="border-left vh-full"
                            sm={9}
                        >
                            <Tab.Content>
                                {users.map((user, index) => (
                                    <UserData
                                        key={user.login}
                                        index={index}
                                        administeredUser={user}
                                    />
                                ))}
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>
        </div>
    )
}